export enum ContentSlotID {
    SHIPPING_BANNER = 'shipping-banner-message',
    TOP_HEADER = 'top-header-message',
}
